import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

export const AUTH_EXTENSIONS = new InjectionToken<IAuthExtensionsService>('AUTH_EXTENSIONS');

export interface IAuthExtensionsService {
  logout(): Observable<any>;
}
